import { action, runInAction } from 'mobx'
import { AsyncPrompt } from '@/infra/AsyncPrompt'
import { ModalViewModel } from '@/infra/ModalViewModel'

/**
 * View model for confirming the removal of a document from its request slot.
 */
export class RemoveDocumentRequestDialogViewModel {
  readonly modal = new ModalViewModel()

  private readonly _prompt = new AsyncPrompt<boolean>({
    abort$: this.modal.close$,
  })

  /**
   * Asks the user to confirm the removal.
   *
   * @returns Whether the user confirmed.
   */
  async prompt(signal?: AbortSignal) {
    this.modal.close()

    const responsePromise = this._prompt.prompt(signal)
    runInAction(() => {
      this.modal.show()
    })

    const response = await responsePromise
    this.modal.close()

    return response ?? false
  }

  @action.bound
  confirm() {
    this._prompt.respond(true)
  }

  @action.bound
  cancel() {
    this.modal.close()
  }
}
